<script>
export default {
  name: 'Variable',
  render () {
    return this.$scopedSlots.default(this.$attrs)
  }
}
</script>
